/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/sap-abap/SapAbapOutboundConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SapAbapOutboundConfigCardTestIds = {
  btnEditSapAbapConfig: "btn-edit-sap-abap-config",
  cardTitleSapAbapConfig: "card-title-sap-abap-config",
  sapAbapConfigSection: "sap-abap-config-section"
} as const;
